import React, { useEffect, useState } from 'react';
import { Drawer, Input, Pagination, Popconfirm, Select } from 'antd';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useMasterUserSelector } from '../../../../redux/selector';
import { fetchApiDelete, fetchApiGet, getApiFilterPackage, getUrlPage } from 'utils/helper';
import { API_CREAT_TICKET_PACKAGE, NUM_TICKET_ON_PAGE } from 'config/data';
import { MEDIA_TYPE, ROLE_NAME, TYPE_PACKAGE, TYPE_TICKET } from 'utils/data';
import { AppState } from 'interface/stateApp';
import toast, { NotifyType } from 'utils/toast';
import { DeleteOutlined, EditOutlined, PlusOutlined } from '@ant-design/icons';
import { TicketPackage } from 'interface/TicketPackage';
import EditTicket from './EditTicket';
import { getSessionByName, removeSessionByName, setSessionByName } from 'utils/sessionStorage';

const { Option } = Select;

export const TicketStore: React.FC = () => {
  const location = useLocation();
  const { typeTicket } = useParams();
  const [ticketPackages, setTicketPackages] = useState<TicketPackage[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [ticketSize, setTicketSize] = useState(0);
  const [selectPackage, setSelectPackage] = useState<TicketPackage | null>(null);
  const user = useMasterUserSelector();
  const [action, setAction] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [stateApp, setStateApp] = useState<AppState>({
    showQnTicketForm: false,
    showReportForm: false,
    showDrawerEditPackage: false,
  });

  const navi = useNavigate();

  const handleUpdateTicketpackages = (ticket: any) => {
    setTicketPackages((prevTickets) => {
      const ticketExists = prevTickets.some((t) => t.id === ticket.id);
      if (ticketExists) {
        return prevTickets.map((t) => (t.id === ticket.id ? { ...t, ...ticket } : t));
      } else {
        return [...prevTickets, ticket];
      }
    });
  };

  const showDrawer = (value: any) => {
    setAction(value);
    setStateApp({ ...stateApp, showDrawerEditPackage: true });
    setSelectPackage(null);
  };

  const showDrawerEditTicket = (ticket: any) => {
    showDrawer('edit');
    setSelectPackage(ticket);
  };
  const onClose = () => {
    setStateApp({ ...stateApp, showDrawerEditPackage: false });
  };

  const getData = async (page?: number) => {
    let pageSend = page ? page : currentPage;
    if (typeTicket === undefined) {
      return;
    }
    if (
      typeTicket.toLowerCase() === TYPE_TICKET.TYPE_TICKET_PRACTICE.toLowerCase() ||
      typeTicket.toLowerCase() === TYPE_TICKET.TYPE_TICKET_QUESTION.toLowerCase()
    ) {
      setSessionByName('typeTicket', typeTicket.toUpperCase());
    }
    let url = getUrlPage(getApiFilterPackage(typeTicket), pageSend, NUM_TICKET_ON_PAGE);

    const data: any = await fetchApiGet(url);
    if (data !== null) {
      setTicketPackages(data['content']);
      setTicketSize(data['totalElements']);
    }
  };

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    getData(page);
  };

  const handleDelete = async (ticketId: any) => {
    const response = await fetchApiDelete(`${API_CREAT_TICKET_PACKAGE}/${ticketId}`, MEDIA_TYPE.JSON);
    if (response !== null) {
      setTicketPackages((prevTickets) => prevTickets.filter((ticket) => ticket.id !== ticketId));
      toast(NotifyType.SUCCESS, 'Xóa gói thành công!');
    } else {
      toast(NotifyType.SUCCESS, 'Không thể xóa gói này!');
    }
  };

  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    let input = event.currentTarget.value;
    if (event.key === 'Enter') {
      if (input !== '') {
        navi(`/master-setting/ticket-store/search&${input}`);
      } else {
        navi(`/master-setting/ticket-store/${getSessionByName('typeTicket')}`);
      }
    }
  };

  const handleOnchangeSelect = (value: string) => {
    if (value === 'all') {
      navi(`/master-setting/ticket-store/${getSessionByName('typeTicket')}`);
    } else {
      navi(`/master-setting/ticket-store/typePackage&${value}`);
    }
  };

  useEffect(() => {
    setCurrentPage(0);
    getData();
  }, [user, typeTicket]);

  useEffect(() => {
    if (!location.pathname.startsWith('/master-setting/ticket-store/')) {
      removeSessionByName('typeTicket');
      console.log('change page remove session');
    }
    // Chạy mỗi khi đường dẫn thay đổi
  }, [location.pathname]);

  return (
    <div className="container flex flex-col mx-auto p-4 h-[98%]">
      <Drawer
        title="Thêm gói mới"
        width={500}
        onClose={onClose}
        open={stateApp.showDrawerEditPackage}
        bodyStyle={{ paddingBottom: 80 }}
        placement="right"
      >
        <EditTicket
          action={action}
          initTicketPackage={selectPackage || undefined}
          onData={handleUpdateTicketpackages}
          onClose={onClose}
          ticketType={typeTicket}
        ></EditTicket>
      </Drawer>
      <div className="p-2 flex items-center justify-between bg-white rounded">
        <div className="flex gap-4">
          <button
            className="py-1 bg-[#3498db] hover:bg-[#2980b9] flex items-center rounded px-2 text-white"
            onClick={() => showDrawer(Date.now())}
          >
            <PlusOutlined className="text-[15px]" />
            <span className="pl-2">Thêm mới</span>
          </button>
          <div className="min-w-[170px] max-w-[170px] flex items-center gap-2">
            <Select
              className="w-full"
              placeholder="Loại gói - Tất cả"
              defaultValue={'all'}
              style={{ flex: 1 }}
              onChange={(value) => handleOnchangeSelect(value)}
            >
              <Option value="all">Loại gói - Tất cả</Option>
              <Option value={TYPE_PACKAGE.TICKET}>Gói theo điểm</Option>
              <Option value={TYPE_PACKAGE.MONTH}>Gói theo tháng</Option>
            </Select>
          </div>
        </div>
        <Input placeholder="Nhập từ khóa tìm kiếm" name="keyword" className="w-fit" onKeyDown={handleKeyPress} />
      </div>
      <div className="flex flex-col bg-white h-[100%] p-2 rounded-sm">
        <div className="overflow-x-auto bg-white">
          <table className="min-w-full bg-white border border-gray-300">
            <thead className="bg-[#f2f2f2]">
              <tr>
                <th className="border border-gray-300 text-center py-3 px-4 font-semibold text-sm">Chọn</th>
                <th className="border border-gray-300 text-left py-3 px-4  font-semibold text-sm">Tên gói</th>
                <th className="border border-gray-300 text-center py-3 px-4  font-semibold text-sm">Loại gói</th>
                <th className="border border-gray-300 text-center py-3 px-4  font-semibold text-sm">Giá gốc</th>
                <th className="border border-gray-300 text-center py-3 px-4  font-semibold text-sm">Giá sau giảm</th>
                <th className="border border-gray-300 text-center py-3 px-4  font-semibold text-sm">Hành động</th>
              </tr>
            </thead>
            <tbody className="text-gray-700">
              {ticketPackages?.map((ticket: any) => (
                <tr key={ticket.id}>
                  <td className="border border-gray-300 text-center py-3 px-4 break-words">
                    <input type="checkbox" />
                  </td>
                  <td className="border border-gray-300 text-left py-3 px-4 break-words cursor-pointer">
                    {ticket?.name}
                  </td>
                  <td className="border border-gray-300 text-center py-3 px-4 break-words">
                    {ticket.typePackage === TYPE_PACKAGE.TICKET ? 'Gói theo điểm' : 'Gói theo tháng'}
                  </td>
                  <td className="border border-gray-300 text-center py-3 px-4 break-words">{ticket.originalPrice}đ</td>
                  <td className="border border-gray-300 text-center py-3 px-4 break-words">{ticket?.discountPrice}đ</td>

                  {user !== null && user?.role === ROLE_NAME.ROLE_ADMIN ? (
                    <td className="flex items-center justify-center border border-gray-300 text-center py-3 border-b-0">
                      <button
                        className="bg-blue-500 hover:bg-blue-700 text-white py-1 rounded-lg mx-1 w-[40px]"
                        onClick={() => showDrawerEditTicket(ticket)}
                      >
                        <EditOutlined />
                      </button>
                      <Popconfirm
                        title="Xóa gói điểm"
                        description="Xác nhận xóa gói điểm. Hành động này không thể hoàn tác?"
                        onConfirm={() => handleDelete(ticket?.id)}
                        okText="Đồng ý"
                        cancelText="Hủy"
                      >
                        <button className="bg-red-500 hover:bg-red-700 text-white py-1 rounded-lg mx-1 w-[40px]">
                          <DeleteOutlined />
                        </button>
                      </Popconfirm>
                    </td>
                  ) : null}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {/* <div className="flex-grow"></div> */}
        <div className="flex justify-end mt-3 mb-2">
          <Pagination
            defaultCurrent={currentPage}
            total={ticketSize}
            pageSize={NUM_TICKET_ON_PAGE}
            onChange={handlePageChange}
          />
        </div>
      </div>
    </div>
  );
};
